/* tslint:disable */
/* eslint-disable */
export enum UtilityCategory {
    Water = 'WATER',
    Sewer = 'SEWER',
    WaterDrainage = 'WATER_DRAINAGE',
    Gas = 'GAS',
    Electricity = 'ELECTRICITY'
}
